<ca-modal-container
    modalTitle="{{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.TITLE' | translate }}"
    description="{{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.DESCRIPTION' | translate }}"
    (dismiss)="closeModal(false)"
>
    <div class="validation-error-wrapper">
        <div class="validation-error-item mb-4" *ngIf="validationErrors['special_characters'].length > 0">
            <div class="error-message">
                {{
                    'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.VALIDATION_ERRORS.SPECIAL_CHARACTERS'
                        | translate: { total: validationErrors['special_characters'].length }
                }}
            </div>
            <ul class="valid-message">
                <li *ngFor="let name of validationErrors['special_characters']">{{ name }}</li>
            </ul>
        </div>

        <div class="validation-error-item mb-4" *ngIf="validationErrors['file_type'].length > 0">
            <div class="error-message">
                {{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.VALIDATION_ERRORS.FILE_ENDING' | translate: { total: validationErrors['file_type'].length } }}
            </div>
            <ul class="valid-message">
                <li *ngFor="let name of validationErrors['file_type']">{{ name }}</li>
            </ul>
        </div>

        <div class="validation-error-item mb-4" *ngIf="validationErrors['max_file_size'].length > 0">
            <div class="error-message">
                {{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.VALIDATION_ERRORS.MAX_FILE_SIZE' | translate: { total: validationErrors['max_file_size'].length } }}
            </div>
            <ul class="valid-message">
                <li *ngFor="let name of validationErrors['max_file_size']">{{ name }}</li>
            </ul>
        </div>
        <div class="validation-error-item mb-4" *ngIf="validationErrors['same_name_exists'].length > 0">
            <div class="error-message">
                {{
                    'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.VALIDATION_ERRORS.SAME_NAME_EXISTS' | translate: { total: validationErrors['same_name_exists'].length }
                }}
            </div>
            <ul class="valid-message">
                <li *ngFor="let name of validationErrors['same_name_exists']">{{ name }}</li>
            </ul>
        </div>
        <div class="validation-error-item mb-4" *ngIf="validationErrors['same_name_exists_more_than_once'].length > 0">
            <div class="error-message">
                {{
                    'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.VALIDATION_ERRORS.SAME_NAME_EXISTS_MORE_THAN_ONCE'
                        | translate: { total: validationErrors['same_name_exists_more_than_once'].length }
                }}
            </div>
            <ul class="valid-message">
                <li *ngFor="let name of validationErrors['same_name_exists_more_than_once']">{{ name }}</li>
            </ul>
        </div>
    </div>

    <div class="mt-3" *ngIf="hasSomeValidFiles">
        {{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.INFO' | translate }}
    </div>

    <div class="d-flex justify-content-end mt-3">
        <button type="button" (click)="closeModal(false)" class="me-2 btn btn-secondary" data-uit="file-upload-confirm-dialog-cancel-btn">
            {{ 'GENERAL.CANCEL' | translate }}
        </button>
        <button type="button" [disabled]="!hasSomeValidFiles" (click)="closeModal(true)" class="me-2 btn btn-primary">
            {{ 'UPLOADER.FILE_UPLOAD_CONFIRM_DIALOG.UPLOAD_VALID_FILES_BTN' | translate }}
        </button>
    </div>
</ca-modal-container>
